import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import JSZip from "jszip";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

// JS Files
import MuiButton from "../shares/MuiButton";
import useFetch from "../../context/useFetch";
import MuiTextAreaHook from "../shares/MuiTextAreaHook";
import UploadedFileBox from "../record/UploadedFileBox";
import MuiUpload from "../shares/MuiUpload";
import RemoveFileModal from "../record/RemoveFileModal";

// Others File

const NewRequest = (props) => {
  let windowWidth = window.screen.width;
  const navigate = useNavigate();
  const { type } = useParams();

  const {
    watch,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      description: "",
    },
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [selectedFile, setSelectedFile] = useState();
  const [file, setFile] = useState([]);
  const [removeFileModal, setRemoveFileModal] = useState(undefined);
  const [postData, setPostData] = useState({});

  const handleRemoveFileModal = () => {
    setRemoveFileModal((before) => !before);
  };

  const addFile = (f) => {
    setFile([...file, f]);
  };
  const removeFile = () => {
    let files = [...file];
    files.splice(selectedFile, 1);
    setFile(files);
    setRemoveFileModal(false);
  };

  const PostTicketApi = useFetch({
    method: "post",
    url: "Ticket_Service",
    trigger: false,
    data: postData,
    noHeader: true,
    argFunc: (res) => {
        setIsLoading(false);

      if (res.data == "done") {
        reset();
        setFile([]);
        // props.api.reFetch();
        toast.success(`درخواست شما با موفقیت ثبت شد.`, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = (data) => {
    let formData = new FormData();
    setIsLoading(true);

    formData.append("description", data.description);
    formData.append("case", props.caseId);

    if (file.length > 0) {
      const zip = new JSZip();

      file.map((item) => {
        zip.file(item.name, item);
      });
      let a;
      zip.generateAsync({ type: "blob" }).then(function (content) {
        a = new File([content], `${props.caseId}.zip`);
        formData.append("attach_file", a, a.name);
      });

      setTimeout(() => {
        setPostData(formData);
        PostTicketApi.reFetch();
      }, 3000);
    } else {
      setPostData(formData);
      PostTicketApi.reFetch();
    }
  };

  return (
    <>
      {RemoveFileModal && (
        <RemoveFileModal
          openModal={removeFileModal}
          setOpenModal={setRemoveFileModal}
          removeFile={removeFile}
        />
      )}
      <div className="border-t border-dashed p-4 mt-4 px-4">
        <div className=" border-r-4 border-mygray-300 px-4  mb-4">
          <span className="text-sm md:text-base font-bold text-mygray-700">
            ثبت درخواست جدید:
          </span>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {windowWidth > 768 ? (
            <div className="col-span-3">
              <MuiTextAreaHook
                id="outlined-basic"
                variant="outlined"
                size="small"
                label="توضیحات"
                name="description"
                control={control}
                placeholder={
                  type !== "com-damage" && type !== "con-damage"
                    ? "درج  زمینه درخواست مشاوره (شرح حال)"
                    : ""
                }
                register={{
                  required: {
                    value: true,
                    message: "توضیحات را وارد کنید",
                  },
                }}
              />
            </div>
          ) : (
            <MuiTextAreaHook
              id="outlined-basic"
              variant="outlined"
              size="small"
              label="توضیحات"
              name="description"
              placeholder="درج  زمینه درخواست مشاوره (شرح حال)"
              control={control}
              register={{
                required: {
                  value: true,
                  message: "توضیحات را وارد کنید",
                },
              }}
            />
          )}
          <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
            {/* Desktop */}
            <div className="hidden md:border-r-4 md:border-mygray-300 md:px-4 md:flex  md:items-center">
              <span className="font-bold text-mygray-700">
                کاربر گرامی می‌توانید مدارک مربوطه به پرونده را در اینجا آپلود
                نمایید.
              </span>
              <div className="mr-8">
                <MuiUpload setImageFile={addFile} />
              </div>
            </div>
            {/* End Desktop */}
            {/* Mobile */}
            <div className="md:hidden flex flex-col items-center justify-center">
              <div className="border-r-4 border-mygray-300 px-4">
                <span className="text-sm md:text-base font-bold text-mygray-700">
                  کاربر گرامی به منظور{" "}
                  {type == "com-damage"
                    ? "اعتراض"
                    : type == "con-damage"
                    ? "درخواست مشاوره خسارت"
                    : "درخواست مشاوره پزشکی"}{" "}
                  خود لازم است مدارک مربوط به پرونده را بارگذاری نمایید.
                </span>
              </div>
              <div className="mt-4">
                <MuiUpload setImageFile={addFile} />
              </div>
            </div>
            {/* End Mobile */}
            <div className="grid md:grid-cols-2 gap-8 mt-8 mx-4 md:mx-16">
              {file.map((item, index) => {
                return [
                  <UploadedFileBox
                    item={item}
                    index={index}
                    handleRemoveFileModal={handleRemoveFileModal}
                    setSelectedFile={setSelectedFile}
                  />,
                ];
              })}
            </div>
          </div>
          <div className="text-left mt-8 flex justify-between items-center">
            <MuiButton
              onClick={() => navigate("/")}
              type="submit"
              variant="outlined"
              color="primary"
              text="بازگشت"
            />
            {isLoading ? (
              <Box sx={{ display: "flex" }}>
                <CircularProgress/>
              </Box>
            ) : (
              <MuiButton
                // onClick={() => handleRemoveFileModal()}
                type="submit"
                variant="contained"
                color="primary"
                text="ثبت"
                disabled={PostTicketApi.loading}
              />
            )}
          </div>
        </form>
      </div>
    </>
  );
};
export default NewRequest;
